import { avatars } from "../utils/images";

// NOTE: Sample reviews for layout — replace with real guest feedback before launch.
export const reviews = [
  {
    name: "Arun Krishnan",
    place: "Kochi",
    stay: "Business stay",
    rating: 5,
    avatar: avatars[0],
    text: "Spotless room, quick check-in and a front desk that actually answers at 2 AM. Perfectly located near the bus stand — I'll be back on my next Palakkad trip.",
  },
  {
    name: "Meera Nair",
    place: "Thrissur",
    stay: "Family wedding",
    rating: 5,
    avatar: avatars[1],
    text: "We hosted our cousin's reception here and the team handled everything smoothly. The hall looked beautiful and the suites kept the family comfortable together.",
  },
  {
    name: "Rahul Menon",
    place: "Bengaluru",
    stay: "Weekend trip",
    rating: 4,
    avatar: avatars[2],
    text: "Great value for the price. Soundproof rooms made a real difference — slept better than I expected. Wi-Fi was fast enough for my work calls.",
  },
  {
    name: "Anjali Suresh",
    place: "Coimbatore",
    stay: "Conference",
    rating: 5,
    avatar: avatars[3],
    text: "Our team meeting ran without a hitch. Meeting facilities, parking and room service were all organised well. Staff were polite and helpful throughout.",
  },
  {
    name: "Vishnu Prasad",
    place: "Palakkad",
    stay: "Staycation",
    rating: 5,
    avatar: avatars[4],
    text: "Booked the suite for a family get-together. Plenty of space, clean bathrooms and friendly housekeeping. Easily the best stay option in Valakkad.",
  },
  {
    name: "Divya Raj",
    place: "Chennai",
    stay: "Pilgrimage trip",
    rating: 4,
    avatar: avatars[5],
    text: "Comfortable triple room for the three of us, with easy access to transport. The tour desk gave us helpful directions for the next day's travel.",
  },
];
